import { IAPIRoutes } from "../../../../config";

export type IClinicRepository = ReturnType<typeof ClinicRepositoryFactory>;

export const ClinicRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET, POST } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const getClinicID: IGetMyClinicAPI = async () =>
    GET(
      APIRoutes.apiMyClinic,
      {},
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const getClinicFloor: IGetClinicFloorAPI = async (obj) =>
    GET(
      APIRoutes.apiGetClinicFloor.replace("{clinic_id}", String(obj.clinic_id)),
      obj,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const setClinicFloor: ISetClinicFloorAPI = async ({ clinic_id, ...obj }) =>
    POST(
      APIRoutes.apiSetClinicFloor.replace("{clinic_id}", clinic_id?.toString()),
      obj,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const logError: ILogErrorAPI = async (obj) =>
    POST(APIRoutes.apiMixPanelErrorStore, obj, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
    });

  return {
    getClinicFloor,
    getClinicID,
    setClinicFloor,
    logError,
  };
};
